import __ from 'localisation';
import React from 'react';
import LoadingBar from '@hubins/components/LoadingIndicators';
import BackofficeProfileLink from '@hubins/components/BackofficeProfileLink';

const rolesLoadingStateItem = {
  name: <LoadingBar small />,
  national_identity_number: <LoadingBar small />,
  action: <LoadingBar small />,
};

export const rolesLoadingState = [
  rolesLoadingStateItem,
  rolesLoadingStateItem,
  rolesLoadingStateItem,
];

export const rolesTableHeaders = [
  {
    Header: __('name'),
    accessor: 'name',
    Cell: ({ row }) => {
      return row.original.uuid ? <BackofficeProfileLink profileUuid={row.original.uuid}>{row.original.name}</BackofficeProfileLink> : row.original.name;
    },
  },
  {
    Header: __('ssn_org_num'),
    accessor: 'national_identity_number',
    Cell: ({ row }) => {
      return row.original.uuid ? <BackofficeProfileLink profileUuid={row.original.uuid}>{row.original.national_identity_number}</BackofficeProfileLink> : row.original.national_identity_number;
    },
  },
  {
    Header: '',
    accessor: 'action',
    width: 30,
  }
];
